import React, { Component } from 'react'
import Box from "@mui/material/Box";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";

import Divider from '@mui/material/Divider';

import TransactionItem from "../components/ui-components/transactionItem";
import { getURLBase } from "../utils/helperFns";
import Carousel from 'react-material-ui-carousel'
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded';
import LoaderBlock from "../components/ui-components/LoaderBlock";
import axios from 'axios';
import { Stack } from '@mui/material';
export class PastSpendingsScreen extends Component {
    constructor(props) {
        super(props)
        this.url = getURLBase(true) + '/pastspendingdetailsnew';
        this.state = {
            tabSelected: 0,
            isReady: false,
            pastSpendingsDataArr: [],
            monthData: [],
            isPrevAvailable: false,
            isNextAvailable: false,
            monthIndex: 0
        }
    }

    getMonthAndYear = (index) => {
        let d = new Date()
        d.setDate(1);
        d.setMonth(d.getMonth() + index)
        return (d.toLocaleString('en-us', { month: 'short' }) + " " + d.getFullYear())
    }



    handleTabChange = (event, newValue) => {
        this.setState({
            tabSelected: newValue,
        })
    };

    componentDidCatch(error, info) {
        console.log("past spendings screen error", error);
    }

    componentDidMount() {
        this.getPastSpendingData().then((response) => {
            this.carouselIndex = 0;

            this.setState({
                isReady: true,
                pastSpendingsDataArr: [{ indexId: 0, data: response }],
                prefix: this.props.currentViewisMoney ? "£" : "kg",
                // suffix: this.props.currentViewisMoney ? "" : "kg",
                is_prev_all: response.is_prev_all,
                is_next_all: response.is_next_all,
                monthData: response
            })
        }).catch(err => {
        })
    }


    browsePrevMonth() {
        console.log("Browsing Prev Month");
        console.log("Month Index :-", this.state.monthIndex - 1);
        var s = this.state;
        this.setState({ isReady: false });

        this.getPastSpendingData(s.monthIndex - 1).then((response) => {
            this.setState({
                isReady: true,
                monthIndex: s.monthIndex - 1,
                endOfList: response.endOfList,
                is_prev_all: response.is_prev_all,
                is_next_all: response.is_next_all,
                monthData: response
            });
        }).catch(err => {
        })
    }

    browseNextMonth() {
        console.log("Browsing Next Month");
        console.log("Month Index :-", this.state.monthIndex + 1);
        var s = this.state;
        this.setState({ isReady: false });
        this.getPastSpendingData(s.monthIndex + 1).then((response) => {
            this.setState({
                isReady: true,
                monthIndex: s.monthIndex + 1,
                endOfList: response.endOfList,
                is_prev_all: response.is_prev_all,
                is_next_all: response.is_next_all,
                monthData: response
            });
        }).catch(err => {
        })

    }


    getPastSpendingData(indexId = 0) {
        return axios.post(this.url, { gid: this.props.gid, monthId: indexId }).then(
            (response) => {
                return response.data.body.data[0][0];
            }).catch(err => {
                console.log("past spendings screen function internal error", err);
            });
    }

    render() {
        const TabElement = (props) => {
            //console.log("props tabelement - ", props);
            return (
                <Box className="tab-element-component" px={2} sx={{ width: '100%' }}>
                    <Typography
                        variant="h5" fontWeight="800" align="center" paddingTop={0} marginBottom={4}>
                        {this.getMonthAndYear(this.state.monthIndex)}
                    </Typography>
                    {props?.monthData?.all?.map((transaction, index) => (
                        <TransactionItem key={index} prefix={this.state?.prefix} transaction={transaction} co2DataPresent={true} />
                    ))}
                </Box>
            )
        }

        return (
            <Card className="popup" id="child_PastSpendingsScreen" sx={{ height: '100%' }}>
                <Box className="popupClose">
                    <IconButton aria-label="Close" onClick={this.props.toggleHandler}>
                        <ArrowBackIcon />
                    </IconButton>
                </Box>
                <Box className="popupHeader">
                    <Typography variant="h4" align="center" fontWeight={700} gutterBottom>All Past Spendings</Typography>
                    <Divider light />
                </Box>
                <Box className="popupBody" pt={{ xs: 7, sm: 2 }} pb={2} sx={{ height: '100%', overflowY: 'scroll' }}>
                    <Stack spacing={2} direction={"row"} justifyContent={"space-between"} alignItems={"center"} position={"relative"} marginBottom={-6} zIndex={10}>
                        <IconButton aria-label="prev-icon" color="primary" size='large' disabled={this.state.is_prev_all == "Y" ? false : true}
                            onClick={() => this.browsePrevMonth()}>
                            <ArrowLeftRoundedIcon sx={{ fontSize: 40 }} />
                        </IconButton>
                        <IconButton aria-label="next-icon" color="primary" size='large' disabled={this.state.is_next_all == "Y" ? false : true}
                            onClick={() => this.browseNextMonth()}>
                            <ArrowRightRoundedIcon sx={{ fontSize: 40 }} />
                        </IconButton>
                    </Stack>

                    <Box>
                        {
                            this.state.isReady ? (
                                <Carousel className="w-100 h-100" autoPlay={false} animation="slide"
                                    index={this.carouselIndex}
                                    fullHeightHover={false}
                                    navButtonsAlwaysVisible={false}
                                    navButtonsAlwaysInvisible={true}
                                    cycleNavigation={false}
                                    indicators={false}
                                    swipe={false}
                                    navButtonsProps={{
                                        className: "owlNavButton",
                                        style: {
                                            backgroundColor: 'transparent',
                                            color: "#82B879",
                                            fontSize: 50,
                                        }
                                    }}
                                    navButtonsWrapperProps={{   // Move the buttons to the bottom. Unsetting top here to override default style.
                                        style: {
                                            top: '-2rem',
                                        }
                                    }}
                                    activeIndicatorIconButtonProps={{
                                        style: {
                                            color: '#82B879'
                                        }
                                    }}
                                >

                                    <TabElement className="tab-element" monthData={this.state.monthData} />

                                </Carousel>) : <LoaderBlock />}
                    </Box>
                </Box>
            </Card>
        );
    }
}

export default PastSpendingsScreen
